export const trackNavClick = (
  category?: string,
  subCategory?: string,
  subSubCategory?: string,
  text?: string,
  url?: string,
) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    const eventPayload = {
      event: "click_menu_header",
      menu_item_category: category || "",
      menu_item_sub_category: subCategory || "",
      menu_item_sub_sub_category: subSubCategory || "",
      link_text: text || "",
      link_url: url || "",
    };
    window.dataLayer.push(eventPayload);
  }
};
